/**
 * Enterprise Setup routes (FSD 1.2.1).
 *
 * `src/router/index.ts` is shared with eight sibling C14 packets, so this module
 * declares its records and the wiring pass spreads `ENTERPRISE_SETUP_ROUTES` in —
 * the same arrangement `modules/org/routesC1.ts` uses.
 *
 * Both routes are gated on `foundation.enterprise.read`, the **read** half, deliberately.
 * Every write on these screens is checked on the action (`manage` for propose /
 * validate / submit, `activate` for Apply and Reject, and the three specific manage
 * codes for defaults, flags and packs), so an Auditor holding only the read code can
 * open the workspace, read the configuration change log and the platform-flag history —
 * FSD 1.2.1.12's own reports — and change nothing. Gating the route on `manage` would
 * make the audit impossible, which is the opposite of what the feature is for.
 */

import type { RouteRecordRaw } from 'vue-router'

import { ENTERPRISE_PERMISSIONS } from '@/modules/enterprise/setup/permissions'

export const ENTERPRISE_SETUP_ROUTES: RouteRecordRaw[] = [
  {
    path: '/enterprise/setup',
    name: 'enterprise-setup',
    component: () => import('@/modules/enterprise/setup/EnterpriseWorkspaceView.vue'),
    meta: {
      titleKey: 'enterprise.setup.routeTitles.workspace',
      permission: ENTERPRISE_PERMISSIONS.enterpriseRead,
    },
  },
  {
    path: '/enterprise/setup/wizard',
    name: 'enterprise-setup-wizard',
    component: () => import('@/modules/enterprise/setup/EnterpriseSetupWizardView.vue'),
    meta: {
      titleKey: 'enterprise.setup.routeTitles.wizard',
      permission: ENTERPRISE_PERMISSIONS.enterpriseRead,
    },
  },
]
